import { render } from "./addUser.vue?vue&type=template&id=57dc12b0"
import script from "./addUser.vue?vue&type=script&lang=js"
export * from "./addUser.vue?vue&type=script&lang=js"

import exportComponent from "D:\\zhang\\项目\\经皮黄疸仪\\jaundiceweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__